import { type SavedLayerVisibility } from "../contexts/map-layers-context";

type VisibilityConfig = Record<string, { visibilityTypeKey?: string }>;

export function filterSavedVisibility(
  savedVisibility: SavedLayerVisibility | null,
  availableTypes: Set<string> | ReadonlySet<string>,
  visibilityConfig: VisibilityConfig,
): SavedLayerVisibility | null {
  if (savedVisibility === null) return null;

  return Object.entries(savedVisibility).reduce<SavedLayerVisibility>(
    (acc, [key, entry]) => {
      if (visibilityConfig[key]?.visibilityTypeKey !== "type") {
        acc[key] = entry;
        return acc;
      }

      const hiddenTypes = entry?.hiddenTypes ?? [];
      const filteredHiddenTypes = hiddenTypes.filter((type) =>
        availableTypes.has(type),
      );

      acc[key] = {
        ...entry,
        hiddenTypes:
          filteredHiddenTypes.length > 0 ? filteredHiddenTypes : undefined,
      };

      return acc;
    },
    {},
  );
}
